import Yggdrasil from 'services/yggdrasil'
import { mapCourseToTitle, mapGetRibbons, mapGetTimeBasedRibbons } from 'store/shared/courseHelper'
import moment from 'moment'
import { formattedDateForCountry } from 'components/shared/mixins/dateHelper'

const state = {
    coursesList: [],
    singleCourse: null,
    categories: [],
    coursesLimit: [],
    courseWithLiveEvent: null,
    courseVideo: null,
    featuredContent: [],
    mostPopularLearningPaths: [],
    mostPopularCourses: [],
    upcomingLiveEvents: [],
    mostPopularCoursesInUsersMostPopularPackage: {
        package: {
            code: null,
            name: null
        },
        courses: []
    },
    customerSpecificCourses: [],
    upcomingDigitalClassrooms: [],
    recentlyAddedCourses: [],
    digitalClassRoomEventsForSingleCourse: [],
    signedUpEvents: [],
    allDigitalClassRoomEvents: [],
    lspSupportedFormats: [],
    lspSupportedLanguages: [],
    lspFile: null,
    lspExportErrors: []
}

const mutations = {
    ASSIGN_COURSES_LIST (state, list) {
        state.coursesList = list
    },
    ASSIGN_SINGLE_COURSE (state, single) {
        state.singleCourse = single
    },
    INCREASE_COURSES_LIMIT (state, packageLimit) {
        const index = state.coursesLimit.find(limit => limit.id === packageLimit.id)
        if (index === undefined) {
            state.coursesLimit.push(packageLimit)
        } else {
            state.coursesLimit[state.coursesLimit.findIndex(el => el.id === packageLimit.id)] = packageLimit
        }
    },
    ASSIGN_COURSE_WITH_LIVE_EVENT (state, courseWithLiveEvent) {
        state.courseWithLiveEvent = courseWithLiveEvent
    },
    CLEAR_COURSE_WITH_LIVE_EVENT (state) {
        state.courseWithLiveEvent = null
    },
    ASSIGN_SINGLE_COURSE_VIDEO (state) {
        state.courseVideo = null
        if (state.singleCourse.elements && state.singleCourse.elements.length > 0) {
            state.courseVideo = state.singleCourse.elements.find(element => element.type === 'video')
        }
    },
    CHANGE_SINGLE_COURSE_VIDEO (state, courseVideo) {
        state.courseVideo = courseVideo
    },
    ASSIGN_FEATURED_CONTENT_LIST (state, featuredContent) {
        state.featuredContent = featuredContent
    },
    ASSIGN_MOST_POPULAR_LIST (state, mostPopular) {
        state.mostPopularCourses = mostPopular.courses
        state.mostPopularLearningPaths = mostPopular.learningPaths
    },
    ASSIGN_MOST_POPULAR_COURSES_LIST_IN_MOST_POPULAR_PACKAGE (state, mostPopularCourses) {
        state.mostPopularCoursesInUsersMostPopularPackage = mostPopularCourses
    },
    ASSIGN_UPCOMING_DIGITAL_CLASSROOMS_LIST (state, upcomingDigitalClassrooms) {
        state.upcomingDigitalClassrooms = upcomingDigitalClassrooms
    },
    ASSIGN_CUSTOMER_SPECIFIC_COURSES_LIST (state, customerSpecificCourses) {
        state.customerSpecificCourses = customerSpecificCourses
    },
    ASSIGN_UPCOMING_LIVE_EVENTS_LIST (state, upcomingDigitalClassrooms) {
        state.upcomingLiveEvents = upcomingDigitalClassrooms
    },
    ASSIGN_RECENTLY_ADDED_COURSES (state, recentlyAddedCourses) {
        state.recentlyAddedCourses = recentlyAddedCourses
    },
    ASSIGN_DIGITAL_CLASSROOM_SIGNUPS_FOR_SINGLE_COURSE (state, events) {
        state.digitalClassRoomEventsForSingleCourse = events
    },
    ASSIGN_SIGNED_UP_EVENTS_FOR_USER (state, signedUpEvents) {
        state.signedUpEvents = signedUpEvents
    },
    ASSIGN_ALL_DIGITAL_CLASSROOM_EVENTS (state, allEvents) {
        state.allDigitalClassRoomEvents = allEvents
    },
    CLEAR_AFTER_LOGOUT (state) {
        state.signedUpEvents = []
        state.digitalClassRoomEventsForSingleCourse = []
    },
    ASSIGN_LSP_SUPPORTED_FORMATS (state, formats) {
        state.lspSupportedFormats = formats
    },
    ASSIGN_LSP_SUPPORTED_LANGUAGES (state, languages) {
        state.lspSupportedLanguages = languages
    },
    ASSIGN_LSP_FILE (state, lspFile) {
        state.lspFile = lspFile
    },
    ASSIGN_LSP_EXPORT_ERRORS (state, errors) {
        state.lspExportErrors = errors
    }
}
const actions = {
    async clearAfterLogout (store) {
        store.commit('CLEAR_AFTER_LOGOUT')
    },
    async loadCollectionCourses (store, collectionSlug) {
        const id = collectionSlug.split('-')[0]
        const courses = await Yggdrasil.loadCollectionCoursesById(id)
        store.commit('ASSIGN_COURSES_LIST', courses)
    },
    async loadLearningPathCoursesBySlug (store, learningPathSlug) {
        const courses = await Yggdrasil.loadLearningPathCoursesBySlug(learningPathSlug)
        store.commit('ASSIGN_COURSES_LIST', courses)
    },
    async loadCourses (store, packageId) {
        const courses = await Yggdrasil.loadCourses(packageId)
        store.commit('ASSIGN_COURSES_LIST', courses)
    },
    async loadSingleCourse (store, courseSlug) {
        const id = courseSlug.split('-')[0]
        let course = await Yggdrasil.loadCourseById(id)
        if (course.elements && course.elements.length > 0) {
            course.isMicrolearning = !!course.elements.find(element => element.type === 'section')
        }
        store.commit('ASSIGN_SINGLE_COURSE', course)
        store.commit('ASSIGN_SINGLE_COURSE_VIDEO')
    },
    async clearSingleCourse (store) {
        store.commit('ASSIGN_SINGLE_COURSE', null)
    },
    changeCourseVideo (store, courseVideo) {
        if (store.rootGetters.isLoggedIn) {
            store.dispatch('VideoPlayer/persistPlays', null, { root: true })
        }
        store.commit('CHANGE_SINGLE_COURSE_VIDEO', courseVideo)
    },
    increaseCoursesLimit (store, packageLimit) {
        store.commit('INCREASE_COURSES_LIMIT', packageLimit)
    },
    loadCourseWithLiveEvent (store) {
        let today = moment().format('YYYY-MM-DD')
        let coursesToday = state.coursesList.filter(course =>
            course.enroll && moment(course.enroll.event_date).format('YYYY-MM-DD') === today && course.enroll.event_time
        )
        let courseWithLiveEvent = null

        if (coursesToday) {
            let formatTime = 'YYYY-MM-DD HH:mm'
            let now = moment().format(formatTime)
            let beforeNow = moment().subtract(15, 'minutes').format(formatTime)
            let afterNow = moment().add(15, 'minutes').format(formatTime)

            coursesToday.filter(course => {
                let eventDate = moment(course.enroll.event_date + ' ' + course.enroll.event_time).format(formatTime)
                let isEventStarting = moment(eventDate).isBetween(now, afterNow, 'minute', '(]')
                let isEventRunning = moment(eventDate).isBetween(beforeNow, now, 'minute', '[]')

                if (isEventRunning || isEventStarting) {
                    courseWithLiveEvent = {
                        course: course,
                        status: isEventStarting ? 'starting' : 'running'
                    }
                }
            })
        }
        store.commit('ASSIGN_COURSE_WITH_LIVE_EVENT', courseWithLiveEvent)
    },
    clearCourseWithLiveEvent (store) {
        store.commit('CLEAR_COURSE_WITH_LIVE_EVENT')
    },
    async loadFeaturedContent (store) {
        const featuredContent = await Yggdrasil.loadFeaturedContent()
        store.commit('ASSIGN_FEATURED_CONTENT_LIST', [...featuredContent.learningPaths, ...featuredContent.courses])
    },
    async loadMostPopular (store) {
        const mostPopular = await Yggdrasil.LoadMostPopular()
        store.commit('ASSIGN_MOST_POPULAR_LIST', mostPopular)
    },
    async loadMostPopularCoursesInUsersMostPopularPackage (store) {
        const mostPopularCoursesInPackage = await Yggdrasil.loadMostPopularCoursesInUsersMostPopularPackage()
        store.commit('ASSIGN_MOST_POPULAR_COURSES_LIST_IN_MOST_POPULAR_PACKAGE', mostPopularCoursesInPackage)
    },
    async loadCustomerSpecificCourses (store) {
        const customerSpecificCourses = await Yggdrasil.loadCustomerSpecificCourses()
        store.commit('ASSIGN_CUSTOMER_SPECIFIC_COURSES_LIST', [...customerSpecificCourses.learningPaths, ...customerSpecificCourses.courses])
    },
    async loadUpcomingDigitalClassrooms (store) {
        const upcomingDigitalClassrooms = await Yggdrasil.loadUpcomingDigitalClassrooms()
        store.commit('ASSIGN_UPCOMING_DIGITAL_CLASSROOMS_LIST', upcomingDigitalClassrooms)
    },
    async loadUpcomingLiveEvents (store) {
        const upcomingLiveEvents = await Yggdrasil.loadUpcomingLiveEvents()
        store.commit('ASSIGN_UPCOMING_LIVE_EVENTS_LIST', upcomingLiveEvents)
    },
    async loadRecentlyAddedCourses (store) {
        const recentlyAddedCourses = await Yggdrasil.loadRecentlyAddedCourses()
        store.commit('ASSIGN_RECENTLY_ADDED_COURSES', recentlyAddedCourses)
    },
    async signUpForDigitalClassRoom (store, event) {
        await Yggdrasil.signUpForDigitalClassRoom(event.courseId, event.eventId)
        await store.dispatch('loadSignedUpEvents')
    },
    async cancelSignUpForDigitalClassRoom (store, event) {
        await Yggdrasil.cancelSignUpForDigitalClassRoom(event.courseId, event.eventId, event.subscriptionId)
        await store.dispatch('loadSignedUpEvents')
    },
    async loadDigitalClassRoomSignUpsForCourse (store, courseId) {
        await store.dispatch('loadSignedUpEvents')
        const events = await Yggdrasil.loadDigitalClassRoomSignUpsForCourse(courseId)
        store.commit('ASSIGN_DIGITAL_CLASSROOM_SIGNUPS_FOR_SINGLE_COURSE', events)
    },
    async loadSignedUpEvents (store) {
        const signedUpEvents = await Yggdrasil.loadSignedUpEventsForUser()
        store.commit('ASSIGN_SIGNED_UP_EVENTS_FOR_USER', signedUpEvents)
    },
    async loadAllDigitalClassRoomEvents (store) {
        const allEvents = await Yggdrasil.loadAllDigitalClassRoomEvents()
        store.commit('ASSIGN_ALL_DIGITAL_CLASSROOM_EVENTS', allEvents)
    },
    async loadSingleDigitalClassRoomEvent (store, eventId) {
        return Yggdrasil.loadSingleDigitalClassRoomEvent(eventId)
    },
    async loadCourseWithId (store, courseId) {
        const course = await Yggdrasil.loadCourseById(+courseId)
        return course
    },
    async loadLspSupportedFormats (store) {
        const formats = await Yggdrasil.loadLspSupportedFormats()
        store.commit('ASSIGN_LSP_SUPPORTED_FORMATS', formats)
    },
    async loadLspSupportedLanguages (store) {
        const languages = await Yggdrasil.loadLspSupportedLanguages()
        store.commit('ASSIGN_LSP_SUPPORTED_LANGUAGES', languages)
    },
    async downloadLspFile (store, { courseId, courseTitle, language, format }) {
        const lspFile =  Yggdrasil.downloadLspFile(courseId, courseTitle, language, format)
        store.commit('ASSIGN_LSP_FILE', lspFile)
    },
    async setLspExportErrors (store, errors) {
        store.commit('ASSIGN_LSP_EXPORT_ERRORS', errors)
    }
}

const getters = {
    getCoursesList: (state) => state.coursesList,
    getSingle: (state) => state.singleCourse,
    getCourseById: (state) => id => state.coursesList.find((course) => +course.id === +id),
    getTitleOfCourseById: (state) => id => mapCourseToTitle(state.coursesList.find((course) => +course.id === +id)),
    areThereCourses: (state) => state.coursesList.length > 0,
    mapCourseToRibbon: (state) => mapGetRibbons,
    mapCourseToTimeBasedRibbon: (state) => mapGetTimeBasedRibbons,
    getCoursesLimitByPackage: (state) => id => state.coursesLimit.find((limit) => limit.id === id),
    isLive: (state) => (course) => {
        return course && course.type && course.type.value === 'webinar'
    },
    isDigitalClassRoomTraining: (state) => (course) => {
        return course && course.type && course.type.value === 'virtual_classroom'
    },
    isPodcast: (state) => (course) => {
        return course && course.type && course.type.value === 'podcast'
    },
    isRecording: (state) => (course) => {
        const nonRecording = ['webinar', 'virtual_classroom', 'podcast']
        return course && course.type && !nonRecording.includes(course.type.value)
    },
    isLiveEventActive: (state) => (course) => {
        if (!course.enroll) {
            return false
        }
        return !!course.enroll.active
    },
    getLiveEventDate: (state) => (course) => {
        if (!course.enroll || course.enroll.event_date === '') {
            return null
        }
        return formattedDateForCountry(course.enroll.event_date)
    },
    getLiveEventTime: (state) => (course) => {
        if (!course.enroll) {
            return null
        }
        return course.enroll.event_time
    },
    shouldShowAuthorizationId: (state) => (course) => {
        return course.authorizationId !== '' && !(course.enroll && course.enroll.event_date)
    },
    shouldShowComingSoon: (state) => (course) => {
        let videoDuration = +course.videoDuration === 0 || course.videoDuration === null
        let courseType = course.type?.value === 'course' || course.type?.value === 'wpcourse'
        return videoDuration && courseType
    },
    getCourseWithLiveEvent: (state) => state.courseWithLiveEvent,
    getCourseVideo: (state) => state.courseVideo,
    getFeaturedContent: (state) => state.featuredContent,
    getMostPopularCourses: (state) => state.mostPopularCourses,
    getMostPopularLearningPaths: (state) => state.mostPopularLearningPaths,
    getUpcomingLiveEvents: (state) => state.upcomingLiveEvents,
    getMostPopularCoursesInPackage: (state) => state.mostPopularCoursesInUsersMostPopularPackage,
    getCustomerSpecificCourses: (state) => state.customerSpecificCourses,
    getUpcomingDigitalClassrooms: (state) => state.upcomingDigitalClassrooms,
    getRecentlyAddedCourses: (state) => state.recentlyAddedCourses,
    getEventsForSingleCourse: (state) => state.digitalClassRoomEventsForSingleCourse,
    getSignedUpEventsForUser: (state) => state.signedUpEvents,
    getAllDigitalClassRoomEvents: (state) => state.allDigitalClassRoomEvents,
    getDigitalClassRoomEventsWithCourseId: (state) => id => {
        let eventsByCourseId = state.allDigitalClassRoomEvents.filter((event) => event.course?.id === +id)
        let accessibleEvents = eventsByCourseId.filter(event =>
            moment(event.firstTrainingDateAndTime).unix() > moment().unix() &&
            event.trainingStatus !== 'cancelled' &&
            event.trainingStatus !== 'scheduled'
        ).sort(
            (a, b) => new Date(a.firstTrainingDateAndTime) - new Date(b.firstTrainingDateAndTime)
        )
        return accessibleEvents[0]
    },
    getLspSupportedFormats: (state) => state.lspSupportedFormats,
    getLspSupportedLanguages: (state) => state.lspSupportedLanguages,
    getLspFile: (state) => state.lspFile,
    getLspExportErrors: (state) => state.lspExportErrors
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
